module.exports = __webpack_public_path__ + "static/media/flagModerate.16c8dc6b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/Flags/flagModerate.svg
// module id = 891
// module chunks = 0